/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ token: NonNullable<unknown> }} Metric_Stake_Switch_To_TokenInputs */



/**
* | output |
* | --- |
* | "Switch Stake to {token}" |
*
* @param {Metric_Stake_Switch_To_TokenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_stake_switch_to_token = /** @type {((inputs: Metric_Stake_Switch_To_TokenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Stake_Switch_To_TokenInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Switch Stake to ${i?.token}`)
});